import { render, staticRenderFns } from "./intros.vue?vue&type=template&id=b18d9574&scoped=true&"
import script from "./intros.vue?vue&type=script&lang=js&"
export * from "./intros.vue?vue&type=script&lang=js&"
import style0 from "./intros.vue?vue&type=style&index=0&id=b18d9574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18d9574",
  null
  
)

export default component.exports